import { gql } from '@apollo/client';

export interface ProfileCompletion_UserDataRequest {
  uuid: string;
}

export interface ProfileCompletion_UserData {
  profileCompletion_getProfile: {
    post_profile_completion_route?: string;
    prior_education_experience?: string;
    profile_complete_at?: string | null;
  };
}

export const GET_PROFILE_COMPLETION_USER_DATA = gql`
  query GET_PROFILE_COMPLETION_USER_DATA($uuid: ID!) {
    profileCompletion_getProfile(uuid: $uuid) {
      prior_education_experience
      profile_complete_at
      post_profile_completion_route
    }
  }
`;
